import { render } from "./AddToOrder.vue?vue&type=template&id=b91a171a&scoped=true"
import script from "./AddToOrder.vue?vue&type=script&lang=js"
export * from "./AddToOrder.vue?vue&type=script&lang=js"

import "./AddToOrder.vue?vue&type=style&index=0&id=b91a171a&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b91a171a"]])

export default __exports__